<template lang="pug">
main(v-if="Show")
  parallax-inview
    animation-fade-in-up
      .page-top-image
        .image
          img(src="../assets/shampoo_top_image01.jpg")
        .text
          h1.title Shampoo
            span.title-caption シャンプー
  parallax-inview
    animation-fade-in-up
      .page-description
        p 店頭にて購入が可能です。商品の購入のみも可能ですので、気軽にお立ち寄りください。

  div(v-for="(shampoo, index) in ComputeShampooInfos")
    parallax-inview
      animation-fade-in-up
        section.section-box
          .box-image(@click="ToggleInfoOpen(shampoo.isOpen, index)", :class="{'is-open' : (shampoo.isOpen)}")
            img(:src="ImgUrl(shampoo.image)")
            .box-info
              h3.title {{shampoo.title}}
              .shampoo-info-detail
                p(v-html="shampoo.description")

</template>

<script>
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'
import ShampooDatas from '../datas/Shampoo.json'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室 | Shampoo',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd'],
  components: {
    ParallaxInview,
    AnimationFadeInUp
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    },
    ComputeShampooInfos: {
      get : function() {
        return this.ShampooInfos
      },
      set : function(value) {
        this.ShampooInfos = value
      }
    }
  },
  data: function() {
    return {
      ShampooInfos: ShampooDatas
    }
  },
  methods:{
    ImgUrl: function(image) {
        const path = '/static/images/'
        return path + image;
    },
    ToggleInfoOpen: function(open, index) {
      var tmpShampoo = this.ComputeShampooInfos
      tmpShampoo[index].isOpen = !open
      this.ComputeShampooInfos = tmpShampoo
    }
  }
}
</script>

<style lang="scss" scoped>
.box-image {
  position: relative;
  width: 100%;
  height: 360px;
  margin-bottom: 0;
  overflow: hidden;
  > .box-info {
    position: absolute;
    padding: 8px 12px;
    font-size: 0.8em;
    background: rgba($color: #000000, $alpha: 0.7);
    top: 300px;
    width: 100%;
    box-sizing: border-box;
    transition: top 0.4s cubic-bezier(0.2, 0.8, 0.2, 1);
    > .title {
      padding: 8px 0 14px;
      position: relative;
      &::after {
        position: absolute;
        content: '';
        right: 10px;
        top: 19px;
        width: 10px;
        height: 10px;
        border-top: 1px solid #fff;
        border-right: 1px solid #fff;
        transform: rotate(315deg);
        transition: transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
      }
    }
    > .shampoo-info-detail {
      font-size: 14px;
      padding-bottom: 8px;
      height: 220px;
      text-align: left;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
  &.is-open {
    > .box-info {
      top : 70px;
      > .title {
        &::after {
          top: 10px;
          transform: rotate(135deg);
        }
      }
    }
  }
}

</style>

<style lang="scss">
.shampoo-info-detail {
  .item-section {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Shampoo.vue